import type { GroupUnassigned, UnassignedGroup } from "./types";

export const groupUnassigned: GroupUnassigned = (devices) => {
  const groups = new Map<string, UnassignedGroup>();
  devices.forEach((device) => {
    if (device.kind === "onCircuit") return;
    const id = `${device.kind}|${device.name}`;
    const group = groups.get(id) ?? { name: device.name, kind: device.kind, keys: [] };
    group.keys.push(device.key);
    groups.set(id, group);
  });
  return [...groups.values()].sort((a, b) => b.keys.length - a.keys.length || a.name.localeCompare(b.name));
};
